import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelect2Module } from 'ng-select2';
import { RecaptchaModule, RecaptchaFormsModule, RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
import { ConfigurationService } from '@app/services/configuration.service';

import { ClaimRoutingModule } from './claim.routing.module';
import { ClaimComponent } from './claim.component';
import { ClaimFinalizeComponent } from './finalize/claim-finalize.component';
import { ClaimVerificationComponent } from './verification/claim-verification.component';
import { ClaimService } from './claim.service';
import { ContactUsDialogComponent } from '@app/components/shared-components/contact-us-dialog/contact-us-dialog.component';
import { ManualClaimProfileDialogComponent } from '@app/components/shared-components/manual-claim-profile-dialog/manual-claim-profile-dialog.component';

@NgModule({
  declarations: [
    ClaimComponent,
    ClaimFinalizeComponent,
    ClaimVerificationComponent,
    ContactUsDialogComponent,
    ManualClaimProfileDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ClaimRoutingModule,
    NgSelect2Module,
    RecaptchaModule,
    RecaptchaFormsModule
  ],
  providers: [
    ClaimService,
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey:  ConfigurationService.SETTING_CAPTCHA_SITEKEY } as RecaptchaSettings,
    }
  ]
})
export class ClaimModule { }
